// frontend/src/components/GlobalResultsDrawer.js
// This React component renders a global search results drawer, showing matching drivers grouped by status (Active, Reserved, Banned), with options to open a driver or view the full list.
import React from 'react';
import { useSelector } from 'react-redux';
import { selectGlobalResults } from '../features/drivers/driverSlice';
import { selectFilters } from '../features/ui/filtersSlice';

export default function GlobalResultsDrawer({ onOpen, onViewAll, maxPerGroup = 5 }) {
  const results = useSelector(selectGlobalResults);
  const { q, scope } = useSelector(selectFilters);
  if (scope !== 'global' || !q?.trim()) return null;

  const Section = ({ title, items, status }) => {
    if (!items?.length) return null;
    const rows = items.slice(0, maxPerGroup);
    return (
      <div className="mb-3">
        <div className="flex items-center justify-between mb-1">
          <div className="font-semibold text-sm">{title} <span className="text-gray-500">({items.length})</span></div>
          <button className="text-xs text-blue-600 hover:underline" onClick={() => onViewAll?.(status)}>View all</button>
        </div>
        <ul className="space-y-1">
          {rows.map(r => (
            <li key={`${status}-${r.id}`} className="flex items-center justify-between text-sm bg-gray-50 px-2 py-1 rounded">
              <span>{r.name} • {r.vehicle_registration_number || '—'}</span>
              <div className="flex items-center gap-2">
                <span className="text-xs rounded px-2 py-0.5 bg-gray-200">{status}</span>
                <button className="text-blue-600 hover:underline" onClick={() => onOpen(r)}>Open</button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="mb-4 p-3 border rounded bg-white shadow">
      <div className="text-gray-700 text-sm mb-2">Global results for “{q}”</div>
      <Section title="Active"   items={results.Active}   status="Active" />
      <Section title="Reserved" items={results.Reserved} status="Reserved" />
      <Section title="Banned"   items={results.Banned}   status="Banned" />
    </div>
  );
}
